export const CREATING_FAQS = "CREATING_FAQS";
export const UPDATING_FAQS = "UPDATING_FAQS";
export const FAQS_CREATED = "FAQS_CREATED";
export const FAQS_UPDATED = "FAQS_UPDATED";
export const ERROR_FAQS_CREATE = "ERROR_FAQS_CREATE";
export const ERROR_FAQS_UPDATE = "ERROR_FAQS_UPDATE";
export const UPDATED_RECENTLY = "UPDATED_RECENTLY";
export const SET_UPDATED_RECENTLY_TO_FALSE = "SET_UPDATED_RECENTLY_TO_FALSE";
